"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientScreen = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Screen = require("./Screen");
var _VideoChatCubbyContext = require("../VideoChatCubbyContext");
var _utils = require("../../../utils");
var _types = require("../../../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getAnswer = function getAnswer(question, patientAnswers) {
  var filtered = patientAnswers.filter(function (ans) {
    return ans.questionId === question.id;
  });
  if (filtered.length > 0) {
    return filtered[0].answer;
  }
  return [];
};
var Section = function Section(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-4 text-black tw-label-regular"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-label-sm-medium text-grey-75 py-3"
  }, title), children);
};
var IntakeSection = function IntakeSection(_ref2) {
  var rootQuestions = _ref2.rootQuestions,
    patientAnswers = _ref2.patientAnswers;
  // Wellness factors section
  if (rootQuestions.length > 1) {
    return /*#__PURE__*/_react.default.createElement("ol", {
      className: "tw-label-regular text-black m-0 pl-[24px] flex flex-col gap-y-[8px]"
    }, rootQuestions.map(function (question) {
      var _question$children;
      var rootAnswer = getAnswer(question, patientAnswers)[0];
      return /*#__PURE__*/_react.default.createElement("li", {
        key: question.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex flex-col gap-y-[4px]"
      }, /*#__PURE__*/_react.default.createElement("p", null, question.text, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: rootAnswer === _utils.YES_ANSWER ? 'text-alertred-60' : ''
      }, rootAnswer)), (_question$children = question.children) === null || _question$children === void 0 ? void 0 : _question$children.map(function (childQuestion) {
        var childAnswer = getAnswer(childQuestion, patientAnswers)[0];
        return /*#__PURE__*/_react.default.createElement("p", {
          key: childQuestion.id
        }, childQuestion.text, " ", childAnswer);
      })));
    }));
  }
  var question = rootQuestions[0];
  switch (question.type) {
    case _types.SurveyQuestionTypesEnum.ALLERGIES:
      {
        var patientAnswer = getAnswer(question, patientAnswers);
        return /*#__PURE__*/_react.default.createElement("ol", {
          className: "tw-label-regular text-black m-0 pl-[24px]"
        }, patientAnswer.map(function (answer) {
          var parsedAnswer = JSON.parse(answer);
          return /*#__PURE__*/_react.default.createElement("li", {
            key: answer
          }, parsedAnswer.allergen, ", reaction: ", parsedAnswer.reaction);
        }));
      }
    case _types.SurveyQuestionTypesEnum.OPEN:
      {
        var _patientAnswer$;
        var _patientAnswer = getAnswer(question, patientAnswers);
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "tw-label-regular text-black pl-[8px]"
        }, (_patientAnswer$ = _patientAnswer[0]) !== null && _patientAnswer$ !== void 0 ? _patientAnswer$ : 'None');
      }
    case _types.SurveyQuestionTypesEnum.MULTISELECT:
      {
        var _patientAnswer2 = getAnswer(question, patientAnswers);
        return /*#__PURE__*/_react.default.createElement("ol", {
          className: "tw-label-regular text-black m-0 pl-[24px]"
        }, _patientAnswer2.map(function (answer) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: answer
          }, answer);
        }));
      }
    default:
      {
        return null;
      }
  }
};
var PatientScreen = function PatientScreen() {
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    patient = _useVideoChatCubby.patient,
    intakeSurvey = _useVideoChatCubby.intakeSurvey,
    patientAnswers = _useVideoChatCubby.patientAnswers,
    loadingIntakeSurvey = _useVideoChatCubby.loadingIntakeSurvey;
  return /*#__PURE__*/_react.default.createElement(_Screen.Screen, {
    actionLabel: "Next"
  }, /*#__PURE__*/_react.default.createElement(Section, {
    title: "Profile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-2 gap-x-[8px] gap-y-[8px] pb-[16px]"
  }, /*#__PURE__*/_react.default.createElement("p", null, "First name: ", patient === null || patient === void 0 ? void 0 : patient.firstName), /*#__PURE__*/_react.default.createElement("p", null, "Last name: ", patient === null || patient === void 0 ? void 0 : patient.lastName), /*#__PURE__*/_react.default.createElement("p", null, "Date of birth:", ' ', (0, _utils.formatDateString)(patient === null || patient === void 0 ? void 0 : patient.birthDate, _utils.DateStringFormatEnum.MM_DD_YYYY, 'utc')), /*#__PURE__*/_react.default.createElement("p", null, "Legal sex: ", (0, _lodash.capitalize)(_utils.GenderUtils.getLabel(patient === null || patient === void 0 ? void 0 : patient.sex))), /*#__PURE__*/_react.default.createElement("p", null, "Preferred name: ", (patient === null || patient === void 0 ? void 0 : patient.preferredName) || 'N/A'), /*#__PURE__*/_react.default.createElement("p", null, "Pronouns: ", (patient === null || patient === void 0 ? void 0 : patient.pronoun) || 'N/A'), /*#__PURE__*/_react.default.createElement("p", null, "Phone number: ", (0, _utils.formatPhoneNumber)(patient === null || patient === void 0 ? void 0 : patient.phoneNumber)))), /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingIntakeSurvey
  }, patientAnswers && intakeSurvey && intakeSurvey.sections && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (intakeSurvey === null || intakeSurvey === void 0 ? void 0 : intakeSurvey.updatedAt) && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row justify-between items-center pt-[16px] -mb-[8px]"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-label-sm-medium text-black"
  }, "Intake Form"), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-grey-40 font-medium"
  }, "Last updated:", ' ', (0, _utils.formatDateString)(intakeSurvey === null || intakeSurvey === void 0 ? void 0 : intakeSurvey.updatedAt, _utils.DateStringFormatEnum.DATE_STYLE_SHORT).replaceAll('/', '.'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-[24px] divide-x-0 divide-y divide-dashed divide-grey-40"
  }, Object.entries(intakeSurvey.sections).map(function (_ref3, index) {
    var _ref4 = _slicedToArray(_ref3, 2),
      sectionName = _ref4[0],
      questions = _ref4[1];
    var rootQuestions = (0, _utils.groupIntakeQuestions)(questions, patientAnswers);
    return /*#__PURE__*/_react.default.createElement(Section, {
      key: index,
      title: sectionName
    }, /*#__PURE__*/_react.default.createElement(IntakeSection, {
      rootQuestions: rootQuestions,
      patientAnswers: patientAnswers
    }));
  })))));
};
exports.PatientScreen = PatientScreen;